import _ from 'lodash'
import { createSelector } from 'reselect'

export const getRevisions = state => _.get(state, 'revisionActions.revisions', null)
export const getRevisionsLoading = state => _.get(state, 'revisionActions.loading', false)

// deprecated
export const getRevisionsFromAudit = state => _.get(state, 'auditActions.revisions.data', null)
export const getRevisionsLoadingFromAudit = state => _.get(state, 'auditActions.loading', null)

export const revisionByRevisionNumberSelector = state => revisionNumber =>
  createSelector([getRevisions], revisions =>
    _.find(revisions, { currentRevisionNumber: revisionNumber })
  )(state)



// WEBPACK FOOTER //
// ./src/selectors/revision.js